import {
    Component,
    ChangeDetectionStrategy,
    Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController } from 'flux-core';
import { TeamPortalWindow } from '../team-portal-window/team-portal-window.cmp';

/**
 * This is the payment failed message component.
 *
 * @author shashik
 * @since 2020-12-18
 */

@Component({
    selector: 'payment-failed-message',
    templateUrl: './payment-failed-message.cmp.html',
    styleUrls: [ 'payment-failed-message.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentFailedMessage {

    /**
     * This holds value for show payment fail banner
     */
    @Input() public showPaymentFailedMessage: boolean = false;

    /**
     * Constructor
     */
    public constructor(
        protected modalController: ModalController,
        public translate: TranslateService,
    ) {
    }

    /**
     * This will open billing page in team portal.
     */
    public showBillingPage() {
        this.modalController.show( TeamPortalWindow , { inputs: { page: 'billing' }});
    }

}
